import { render, staticRenderFns } from "./ServicosRecolhimentoRCToggle.vue?vue&type=template&id=00b179df&scoped=true&"
import script from "./ServicosRecolhimentoRCToggle.vue?vue&type=script&lang=js&"
export * from "./ServicosRecolhimentoRCToggle.vue?vue&type=script&lang=js&"
import style0 from "./ServicosRecolhimentoRCToggle.vue?vue&type=style&index=0&id=00b179df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b179df",
  null
  
)

export default component.exports